import * as types from "../actionTypes";

export const setFreeCashFlowByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FREE_CASH_FLOW_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setFreeCashFlowByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FREE_CASH_FLOW_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const setFreeCashFlowInitialPeriod = (key, initialPeriod) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FREE_CASH_FLOW_INITIAL_PERIOD,
      key,
      initialPeriod,
    });
  };
};

export const setFreeCashFlowInitialPeriodMonth = (key, initialPeriod) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_FREE_CASH_FLOW_INITIAL_PERIOD_MONTH,
      key,
      initialPeriod,
    });
  };
};

export const replaceFreeCashFlowInitialYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_FREE_CASH_FLOW_BY_YEARS,
      key,
      payload,
    });
  };
};

export const resetFreeCashFlowReducer = () => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_FREE_CASH_FLOW_REDUCER,
    });
  };
};
